import { z } from 'zod';

export const BattleTeamSchema = z.enum(['white','black']);

export type BattleTeamType = `${z.infer<typeof BattleTeamSchema>}`

export default BattleTeamSchema;
